import React from 'react';
import {
  Container,
  Box,
  Typography,
  Button,
  Paper,
  IconButton
} from '@material-ui/core';
import {
  Share as ShareIcon,
  CardGiftcard as GiftIcon,
  WorkOutline as WorkshopIcon
} from '@material-ui/icons';
import { withStyles } from '@material-ui/core/styles';

import GameTopPanel from '../../component/game/user_interface/gameTopPanel';
import FooterPanel from '../../component/game/user_interface/gameFooterPanel';

const styles = theme => ({
  root: {
    backgroundColor: '#f5f5f5',
    minHeight: '100vh'
  },
  headerBanner: {
    background: 'linear-gradient(135deg, #f5e6d3 0%, #f5d0a9 25%, #f5b380 50%, #f59e6c 75%, #f58b5c 100%)',
    padding: '40px 20px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative'
  },
  headerContent: {
    textAlign: 'center',
    maxWidth: '800px'
  },
  featuredText: {
    color: '#6b4423',
    fontSize: '14px',
    fontWeight: 500,
    marginBottom: '8px',
    letterSpacing: '0.5px'
  },
  mainTitle: {
    color: 'white',
    fontSize: '48px',
    fontWeight: 700,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '16px'
  },
  giftIcon: {
    fontSize: '48px',
    color: '#8b5a3c'
  },
  contentContainer: {
    padding: '40px 20px'
  },
  pageHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: '24px'
  },
  titleSection: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px'
  },
  workshopIcon: {
    fontSize: '24px',
    color: '#666'
  },
  pageTitle: {
    fontSize: '28px',
    fontWeight: 600,
    color: '#333'
  },
  shareButton: {
    color: '#666',
    fontSize: '14px',
    textTransform: 'none',
    fontWeight: 500
  },
  section: {
    marginBottom: '24px'
  },
  sectionTitle: {
    fontSize: '18px',
    fontWeight: 600,
    color: '#333',
    marginBottom: '12px'
  },
  overviewText: {
    fontSize: '14px',
    color: '#666',
    lineHeight: 1.6
  },
  sessionCard: {
    padding: '20px',
    marginBottom: '16px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    border: '1px solid #e0e0e0',
    borderRadius: '8px',
    transition: 'box-shadow 0.2s',
    '&:hover': {
      boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
    }
  },
  sessionInfo: {
    flex: 1
  },
  sessionName: {
    fontSize: '16px',
    fontWeight: 600,
    color: '#333',
    marginBottom: '6px'
  },
  sessionDescription: {
    fontSize: '13px',
    color: '#999'
  },
  hostButton: {
    backgroundColor: '#ff6b6b',
    color: 'white',
    textTransform: 'uppercase',
    fontWeight: 600,
    fontSize: '12px',
    padding: '8px 24px',
    '&:hover': {
      backgroundColor: '#ff5252'
    }
  }
});

class InkspireEventPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      sessions: [
        {
          id: 1,
          name: 'Prompt Storm',
          description: 'Lightning brainstorm session to establish the foundation of jam'
        },
        {
          id: 2,
          name: 'Plot Roulette',
          description: 'Lightning brainstorm session to establish the foundation of jam'
        },
        {
          id: 3,
          name: 'Twist & Tell',
          description: 'Lightning brainstorm session to establish the foundation of jam'
        }
      ]
    };
  }

  render() {
    const { classes } = this.props;
    const { sessions } = this.state;

    return (
        <>
            <GameTopPanel/>
            <Box className={classes.root}>
            {/* Header Banner */}
            <Box className={classes.headerBanner}>
            <Box className={classes.headerContent}>
                <Typography className={classes.featuredText}>
                Featured 2026 Event
                </Typography>
                <Typography className={classes.mainTitle}>
                Inkspire Showdown
                <GiftIcon className={classes.giftIcon} />
                </Typography>
            </Box>
            </Box>

            {/* Main Content */}
            <Container maxWidth="md" className={classes.contentContainer}>
            {/* Page Header */}
            <Box className={classes.pageHeader}>
                <Box className={classes.titleSection}>
                <WorkshopIcon className={classes.workshopIcon} />
                <Typography className={classes.pageTitle}>
                    Inkspire Showdown
                </Typography>
                </Box>
                <Button 
                className={classes.shareButton}
                startIcon={<ShareIcon />}
                >
                SHARE
                </Button>
            </Box>

            {/* Overview Section */}
            <Box className={classes.section}>
                <Typography className={classes.sectionTitle}>
                Overview
                </Typography>
                <Typography className={classes.overviewText}>
                Welcome to the Inkspire Showdown—a high-energy writing jam tournament where creativity meets competition. Writers from all 
                walks of life face off in timed challenges, surprise prompts, and knockout rounds designed to test imagination, style, and 
                stamina. Whether you're a poet, flash-fiction master, or prose powerhouse, this is your chance to shine under pressure and 
                rise through the ranks.
                </Typography>
            </Box>

            {/* Sessions Section */}
            <Box className={classes.section}>
                <Typography className={classes.sectionTitle}>
                Sessions
                </Typography>

                {sessions.map(session => (
                <Paper key={session.id} className={classes.sessionCard} elevation={0}>
                    <Box className={classes.sessionInfo}>
                    <Typography className={classes.sessionName}>
                        {session.name}
                    </Typography>
                    <Typography className={classes.sessionDescription}>
                        {session.description}
                    </Typography>
                    </Box>
                    <Button 
                    variant="contained" 
                    className={classes.hostButton}
                    >
                    HOST
                    </Button>
                </Paper>
                ))}
            </Box>
            </Container>
            </Box>
            <FooterPanel/>
        </>

    );
  }
}

export default withStyles(styles)(InkspireEventPage);